import { Avatar, Col, Row, Tooltip, theme } from "antd";
import { useState } from "react";
import { AttributeField } from "src/components/AttributeField";
import { ContainerArrow } from "src/components/ContainerArrow";
import { Flex } from "src/components/Flex";
import { EntitySummary, ExpandedView } from "./EntitySummary";
import { EntityLink } from "./EntityLink";

export const CollapsibleComment = (props: {
  item: any;
  targetEntity?: any;
}) => {
  const [collapsed, setCollapsed] = useState(
    props.item.entity.properties.uuid !== props.targetEntity?.properties.uuid
  );
  const { token } = theme.useToken();
  // const orgId = useOrg().id;
  // const href = `/org/${orgId}/entity/${props.item.actor?.properties.uuid}`;

  const highlightedCommentStyle: React.CSSProperties = {
    backgroundColor: token.colorBgContainer,
    borderRadius: 5,
  };
  const style =
    props.item.entity.properties.uuid === props.targetEntity?.properties.uuid
      ? highlightedCommentStyle
      : {};
  return (
    <Row
      style={{
        ...style,
        borderBottom: `1px solid ${token.colorBorderSecondary}99`,
      }}
    >
      <Col style={{ width: "30px" }}>
        <ContainerArrow
          mobile
          opened={!collapsed}
          setOpened={setCollapsed}
          size={30}
        />
      </Col>
      <Col style={{ width: "30px" }}>
        <Tooltip title={props.item.actor?.properties.name}>
          <EntityLink uuid={props.item.actor?.properties.uuid}>
            <Avatar
              shape="circle"
              size="small"
              src={props.item.actor?.properties.avatarUrl}
            >
              {props.item.actor?.properties.name
                .split(" ")
                .map((name: string) => name[0].toLocaleUpperCase())
                .join("")}
            </Avatar>
          </EntityLink>
        </Tooltip>
      </Col>
      {!collapsed && (
        <Col
          style={{
            width: "calc(100% - 60px)",
            lineHeight: "24px",
            paddingLeft: 5,
          }}
          className="entity"
        >
          {props.item.entity.properties.body}
          <ExpandedView style={{ marginLeft: "-25px", marginTop: "5px" }}>
            <EntitySummary entity={props.item.entity} />
          </ExpandedView>
        </Col>
      )}
      {collapsed && (
        <Col
          flex="auto"
          style={{
            paddingLeft: 5,
            width: "calc(100% - 60px)",
          }}
        >
          <Flex spaceBetween className="entity" style={{ lineHeight: "22px" }}>
            <div className="trunc" style={{ width: "calc(100% - 60px)" }}>
              {props.item.entity.properties.body}
            </div>
            <div>
              <AttributeField
                className="entity"
                value={props.item.entity.properties.createdAt}
                format={true}
              />
            </div>
          </Flex>
        </Col>
      )}
    </Row>
  );
};
